import axios from "axios";
import api from "../utils/index";

export const onPreRegister = (data) => {
    return api.post('/pre-register', data)
}

export const onSendOTP = (data) => {
    return api.post('/send-OTP', data)
}

export const onSocialVerify = (data) => {
    return api.post(`/social-verify`, data)
}

export const onLogOut = (payload) => {
    return api.post('/logout',payload)
}

export const onProfileUpdate = (data) => {
    return api.put("/update-profile", data)
}

export const onSendOTPVerify = (data) => {
    return api.post('/verify-otp', data)
}

export const getProfileInfo = (id) => {
    return api.get(`/user-profile?user_UUID=${id}`)
}

export const getCreatorProfileInfo = (id) => {
    return api.get(`/publisher-detail?id=${id}`)
}

export const getCreatorKeyMetricsInfo = (id) => {
    return api.get(`/publisher-key-metrics?id=${id}`)
}

export const getCreatorProfileInfoWithOutAuth = (id) => {
    return api.get(`/publisher?id=${id}`)
}

export const getCreatorKeyMetricsInfoWithOutAuth = (id) => {
    return api.get(`/publisher-keymetrics?id=${id}`)
}

export const onCheckValidateCreator = (data) => {
    return api.post(`/validate-creator`, data)
}

export const onAddCreator = (data) => {
    return api.post(`/add-creator`, data)
}

export const onCheckLinkedAccount = (data) => {
    return api.post(`/check-linked-account`, data)
}

export const addOldAccount = (data) => {
    return api.post(`/add-old-account`, data)
}

export const onMapAccounts = (data) => {
    return api.post(`/map-accounts`, data)
}

export const onCheckAccounts = (data) => {
    return api.post(`/check-accounts`, data)
}

export const onCheckUserProfile = (id) => {
    return api.get(`/user-profile?user_UUID=${id}`)
}

export const onGetLinkedAccount = (id) => {
    return api.get(`/get-linked-account`)
}

export const onCheckSocialAccounts = () => {
    return api.get(`/social-accounts`)
}

export const getDisoveryAccount = () => {
    return api.get(`/get-discovery-account`)
}

export const onAddDomainName = (data) => {
    return api.post(`/add-domain`, data)
}

export const onGetProducts = ({ page = 0, limit = 10 }) => {
    return api.get(`/store-products?page=${page}&limit=${limit}`)
}

export const getStoreDetails = () => {
    return api.get('/store')
}

export const onDeleteProduct = (id) => {
    return api.delete(`/delete-product`, { data: { product_id: id } })
}

export const onStoreUpdate = (data) => {
    return api.put("/update-store", data)
}

export const getStoreDetailsPublic = (name) => {
    return api.get(`/creator-store?domname=${name}`)
}

export const getStorePublicApi = (payload, source) => {
    if (source === "shoogloo") {
        return axios.get(`https://stage-creatorpro.myjosh.in/affiliate_store/user/v1/raw_save?p1=${payload.p1}&p2=${payload.p2}&p3=${payload.p3}&p4=${payload.p4}`);
    } else if (source === "cuelinks") {
        return axios.get(`https://stage-creatorpro.myjosh.in/affiliate_store/user/v1/raw_save?subid1=${payload.subid1}&subid2=${payload.subid2}&subid3=${payload.subid3}&subid4=${payload.subid4}`);
    }
}

export const getStoreProductsListPublic = ({ id, page = 0, category_name = "" }) => {
    return api.get(`/storeproducts?domname=${id}&page=${page}&limit=${10}&category_name=${category_name?.replace('&', '%26')}`)
}

export const getConsumerDetails = (name) => {
    return api.get(`/product-categories?domname=${name}`)
}

export const getAffiliateDashboard = (data) => {
    return api.post(`/dashboard`, data)
}

export const onUpdateDomain = (data) => {
    return api.put('/update-domain-status', data)
}

export const onsetProductorders = (data) => {
    return api.put('/set-product-orders', data)
}

export const onGetAffiliateProducts = ({ page = 0, limit = 10 }) => {
    return api.get(`affiliate-products?page=${page}&limit=${limit}`)
}

export const getSavedChanges = () => {
    return api.get(`/save-changes`)
}

export const getDiscardChanges = () => {
    return api.get(`/discard-changes`)
}

export const getGraphDetails = (data) => {
    return api.post(`/clicks-store-graph`, data)
}

export const getSellGraphDetails = (data) => {
    return api.post(`/sell-graph`, data)
}

export const getOutOfStock = () => {
    return api.get(`/check-instock`)
}

export const getAppProfileInfo = (id) => {
    return api.get(`/app-user-profile?user_UUID=${id}`)
}

export const getLanguage = () => {
    return api.get(`/get-languages`)
}

export const getHairColors = () => {
    return api.get(`/get-hair-colors`)
}

export const getHairLength = () => {
    return api.get(`/get-hair-length`)
}

export const getHairType = () => {
    return api.get(`/get-hair-type`)
}

export const getSkinColors = () => {
    return api.get(`/get-skin-color`)
}

export const getEyeColors = () => {
    return api.get(`/get-eye-colors`)
}

export const getStrengths = () => {
    return api.get(`/get-strengths`)
}

export const getVoiceTypes = () => {
    return api.get(`/get-voice-types`)
}

export const getBodyTypes = () => {
    return api.get(`/get-body-types`)
}

export const getAdjectives = () => {
    return api.get(`/get-adjectives`)
}

export const getPhoneBrands = () => {
    return api.get(`/get-phone-brands`)
}

export const getVideoShootingTypes = () => {
    return api.get(`/get-video-shooting-types`)
}

export const getClothingStyles = () => {
    return api.get(`/get-clothing-styles`)
}

export const getFoodPreferences = () => {
    return api.get(`/get-food-preferences`)
}

export const getBodyParts = () => {
    return api.get(`/get-body-parts`)
}

export const addPersonalDetail = (data) => {
    return api.post(`/add-personal-detail`, data)
}

export const addCreatorDetail = (data) => {
    return api.post(`/add-creator-detail`, data)
}

export const getBrand = () => {
    return api.get(`/get-brand`)
}

export const getOtherSkills = () => {
    return api.get(`/get-other-skills`)
}

export const getAwards = () => {
    return api.get(`/get-awards`)
}

export const getPersonalDetail = () => {
    return api.get(`/get-personal-detail`)
}

export const getTattoosBodyParts = () => {
    return api.get(`/get-tattoos-body-parts`)
}

export const getBirthmarkBodyParts = () => {
    return api.get(`/get-birthmark-body-parts`)
}

export const getPiercingBodyParts = () => {
    return api.get(`/get-piercing-body-parts`)
}

export const updatePersonalDetail = (data) => {
    return api.put(`/update-personal-detail`, data)
}

export const onCheckValidateAccount = (data) => {
    return api.post(`/validate-account`, data)
}

export const getProfileDetails = (id) => {
    return api.get(`/get-personal-data?id=${id}`)
}

export const updatePersonalData = (data) => {
    return api.put(`/update-personal-data`, data)
}
export const checkCookies = () => {
    return api.get('check-login', {});
}

export const checkLoginApi = (payload) => {
    return api.post('check-login',payload);
}


export const logOutPublicCreator = () => {
    return api.delete('/logout')
}

export const updateKycDetail = (payload) => {
    return api.put(`/update-kyc-detail`, payload, {
        headers: {
            'Content-Type': 'multipart/form-data', // Set the Content-Type header to multipart/form-data
        },
    })
}

export const addKycDetail = (payload) => {
    return api.post(`/add-kyc`, payload, {
        headers: {
            'Content-Type': 'multipart/form-data', // Set the Content-Type header to multipart/form-data
        },
    })
}

export const getKycDetails = (id) => {
    return api.get(`/kyc-details?josh_user_id=${id}`)
}